module.exports = __webpack_public_path__ + "98b79f9e4c9bdbe1bc557de5b95fd0cc.webp";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/key-art-768.webp
// module id = 433
// module chunks = 0